(() => {
  const componentSelector = '[data-blog-load-more]';

  function initialiseLoadMore(container) {
    if (!container || container.hasAttribute('data-initialised')) {
      return;
    }

    const button = container.querySelector(
      '[data-blog-load-more-button]'
    );

    const status = container.querySelector(
      '[data-blog-load-more-status]'
    );

    const visibleCount = container.querySelector(
      '[data-blog-visible-count]'
    );

    const totalCount = container.querySelector(
      '[data-blog-total]'
    );

    if (!button) return;

    const gridId = button.getAttribute('aria-controls');
    const grid = document.getElementById(gridId);
    const step = Number.parseInt(container.dataset.step, 10) || 6;

    if (!grid) return;

    const allCards = grid.querySelectorAll('.blog-listing-card');
    const actualTotal = allCards.length;

    container.setAttribute('data-initialised', '');

    if (totalCount) {
      totalCount.textContent = actualTotal;
    }

    button.addEventListener('click', () => {
      const hiddenCards = Array.from(
        grid.querySelectorAll('[data-blog-card-hidden]')
      );

      const cardsToReveal = hiddenCards.slice(0, step);

      cardsToReveal.forEach((card, index) => {
        card.style.setProperty(
          '--blog-card-reveal-delay',
          `${index * 60}ms`
        );

        card.classList.remove(
          'blog-listing-card--load-more-hidden'
        );

        card.removeAttribute('data-blog-card-hidden');
        card.classList.add('blog-listing-card--revealed');

        card.addEventListener(
          'animationend',
          () => {
            card.classList.remove(
              'blog-listing-card--revealed'
            );

            card.style.removeProperty(
              '--blog-card-reveal-delay'
            );
          },
          { once: true }
        );
      });

      const remainingCards = grid.querySelectorAll(
        '[data-blog-card-hidden]'
      ).length;

      const currentlyVisible = actualTotal - remainingCards;

      if (visibleCount) {
        visibleCount.textContent = currentlyVisible;
      }

      if (remainingCards === 0) {
        button.hidden = true;

        container.classList.add(
          'blog-listing-load-more--complete'
        );

        if (status) {
          status.textContent =
            `All ${actualTotal} stories shown`;
        }
      }
    });
  }

  function initialiseAll(scope = document) {
    if (
      scope.matches &&
      scope.matches(componentSelector)
    ) {
      initialiseLoadMore(scope);
    }

    if (!scope.querySelectorAll) return;

    scope
      .querySelectorAll(componentSelector)
      .forEach((container) => {
        initialiseLoadMore(container);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initialiseAll()
    );
  } else {
    initialiseAll();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initialiseAll(event.target);
    }
  );
})();